// eslint-disable-next-line import/no-extraneous-dependencies
import { createApp } from "vue";
// eslint-disable-next-line import/no-extraneous-dependencies
import { createPinia } from "pinia";
import TableView from "./vue/TableView.vue";

export default class SortableTable {
  constructor(element) {
    const tableContent = this.getTableContent(element);
    const tableId = this.getTableId(element);
    const tableCaption = this.getTableCaption(element);

    const app = createApp(TableView, { tableContent, tableId, tableCaption });
    const pinia = createPinia();

    app.use(pinia);
    app.mount(element);
  }

  /** @type {TableContents} */
  getTableContent(element) {
    return JSON.parse(element.getAttribute("data-table-content"));
  }

  getTableId(element) {
    return element.getAttribute("data-table-id");
  }

  getTableCaption(element) {
    return element.getAttribute("data-table-caption");
  }
}